import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="flex min-h-screen items-center justify-center bg-ink text-volt">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function AdminEntry() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-ink text-volt">Loading…</div>;
  if (user) return <Navigate to="/admin/dashboard" replace />;
  return <AdminLogin />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<AdminEntry />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
